import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './translations/en.json';
import csTranslations from './translations/cs.json';

// Function to detect browser language
const getBrowserLanguage = () => {
  // Check if browser language is available
  if (typeof window === 'undefined' || !navigator.language) {
    return 'en';
  }

  // Get browser language (e.g., 'cs-CZ', 'en-US', 'cs', 'en')
  const browserLang = navigator.language.toLowerCase();
  
  // Check primary language code (first two characters)
  const langCode = browserLang.split('-')[0];
  
  // Map to supported languages
  const supportedLanguages = {
    'cs': 'cs',  // Czech
    'en': 'en'   // English
  };

  // Return detected language or default to English
  return supportedLanguages[langCode] || 'en';
};

// Get initial language: saved preference > browser language > English
const getInitialLanguage = () => {
  const savedLanguage = localStorage.getItem('eevn-language');
  if (savedLanguage) {
    return savedLanguage;
  }
  return getBrowserLanguage();
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      cs: {
        translation: csTranslations
      }
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

